module.exports = __webpack_public_path__ + "static/media/cards.e9bb9848.png";